/**
 * @author เต้ย
 * @description Permission Manager — เช็คสิทธิ์ CRUD สำหรับ frontend
 * ใช้ window.USER_PERMISSION ที่ inject จาก PHP
 *
 * วิธีใช้:
 * 1. เช็คใน JS: Permission.can('ticket.create')
 * 2. Auto-hide ใน HTML: data-permission="ticket.create"
 * 3. CRUD shortcuts: Permission.canCreate('ticket')
 */

const Permission = {
    _map: null,

    /**
     * สร้าง permission map สำหรับ O(1) lookup
     */
    _initMap() {
        if (this._map !== null) return;
        this._map = {};
        const perms = window.USER_PERMISSION || [];
        for (let i = 0; i < perms.length; i++) {
            this._map[perms[i]] = true;
        }
    },

    /**
     * เช็คว่ามี permission หรือไม่
     * @param {string} name เช่น "ticket.create", "ticket.read"
     * @returns {boolean}
     */
    can(name) {
        this._initMap();
        return this._map[name] === true;
    },

    /**
     * เช็คสิทธิ์อ่าน
     * @param {string} module เช่น "ticket"
     */
    canRead(module) {
        return this.can(module + '.read');
    },

    /**
     * เช็คสิทธิ์สร้าง
     * @param {string} module เช่น "ticket"
     */
    canCreate(module) {
        return this.can(module + '.create');
    },

    /**
     * เช็คสิทธิ์แก้ไข
     * @param {string} module เช่น "ticket"
     */
    canEdit(module) {
        return this.can(module + '.edit');
    },

    /**
     * เช็คสิทธิ์ลบ
     * @param {string} module เช่น "ticket"
     */
    canDelete(module) {
        return this.can(module + '.delete');
    },

    /**
     * เช็คสิทธิ์ export
     * @param {string} module เช่น "ticket"
     */
    canExport(module) {
        return this.can(module + '.export');
    },

    /**
     * ซ่อน elements ที่ user ไม่มีสิทธิ์
     * ใช้ attribute: data-permission="ticket.create"
     * เรียกอัตโนมัติเมื่อ DOM ready
     */
    enforceUI() {
        this._initMap();
        document.querySelectorAll('[data-permission]').forEach((el) => {
            const requiredPerm = el.getAttribute('data-permission');
            if (!this.can(requiredPerm)) {
                el.style.display = 'none';
                el.setAttribute('data-permission-hidden', 'true');
            }
        });
    },

    /**
     * Re-enforce หลัง dynamic content ถูกเพิ่ม (เช่น หลัง AJAX load)
     */
    refresh() {
        this.enforceUI();
    }
};

// Auto-enforce เมื่อ DOM ready
$(document).ready(function () {
    Permission.enforceUI();

    // Auto-refresh หลัง modal แสดง (Bootstrap 5 event)
    $(document).on('shown.bs.modal', function () {
        Permission.refresh();
    });

    // Auto-refresh หลัง AJAX response ที่มี HTML content
    if (typeof axios !== 'undefined') {
        axios.interceptors.response.use(function (response) {
            // Delay เล็กน้อยเพื่อให้ DOM update ก่อน
            setTimeout(function () {
                Permission.refresh();
            }, 100);
            return response;
        });
    }
});
